// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2qGrz","content":"RecentSearches_content__1h1kC"};